import { dispatchWinNotificationFail } from '../internal/winNotificationFail';
import { AdserverRequestId, CreativeBeaconType } from '../types';
import { dispatchCreativeNotifications } from './creativeNotifications';

export const dispatchVideoWinNotifications = (arid: AdserverRequestId) => {
  return dispatchCreativeNotifications({
    arid,
    beaconType: CreativeBeaconType.VideoWinNotification,
    onFailure: (url: string) => {
      dispatchWinNotificationFail(arid, url);
    }
  });
};
